import React from 'react';

const ActiveMetroIcon = ({ width = 10, height = 10, color, background, ...rest }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g filter="url(#filter_metroActive)">
        <circle className="bg" cx="21.5004" cy="19.5004" r="16.8636" fill={background} />
        <circle className="border" cx="21.5004" cy="19.5004" r="16.8636" stroke="#A8080E" />
      </g>
      <path
        className="fg"
        transform="translate(9.26 6.89) scale(1.2)"
        d="M16.0411 13.7941C16.4519 13.5559 16.7079 13.1124 16.7079 12.6361V6.37321C16.7079 5.89397 16.4549 5.45342 16.0411 5.21529L10.6772 2.08383C10.2574 1.83974 9.74248 1.83974 9.32277 2.08085L3.95584 5.21231C3.54506 5.45044 3.28906 5.89397 3.28906 6.37024V12.6302C3.28906 13.1094 3.54208 13.55 3.95584 13.7881L9.3198 16.9196C9.73653 17.1607 10.2545 17.1607 10.6712 16.9196L16.0411 13.7941ZM14.2015 7.93894L10.0699 6.70065C10.0074 6.68279 9.94192 6.68279 9.87643 6.7066L5.81328 8.14433C5.75375 8.16517 5.69719 8.1235 5.69719 8.06098V6.90008C5.69719 6.8346 5.73291 6.77506 5.79244 6.74232L9.89132 4.58126C9.96871 4.54256 10.061 4.53958 10.1354 4.5753L14.2164 6.50121C14.2789 6.53098 14.3176 6.59349 14.3176 6.66195V7.85559C14.3176 7.91215 14.2611 7.9568 14.2015 7.93894ZM14.2134 10.359C14.2134 10.359 10.1354 11.3145 10.0788 11.3264C10.0193 11.3383 9.96276 11.3353 9.89132 11.3175C9.83178 11.3056 5.7597 10.2131 5.7597 10.2131C5.71207 10.2012 5.67933 10.1536 5.67933 10.106V9.2963C5.67933 9.22784 5.721 9.17128 5.78649 9.15045L9.89727 7.81987C9.9568 7.80201 10.0193 7.79904 10.0818 7.8169L14.2224 8.95994C14.27 8.97185 14.3027 9.01947 14.3027 9.0671V10.2548C14.2998 10.3024 14.264 10.3471 14.2134 10.359ZM14.2045 12.8058L10.1265 14.4489C10.0521 14.4787 9.97169 14.4757 9.90322 14.44L5.79244 12.4129C5.72993 12.3831 5.69421 12.3206 5.69421 12.2521V11.2788C5.69421 11.2192 5.75077 11.1776 5.80733 11.1924L9.93299 12.4218C9.98657 12.4367 10.0431 12.4367 10.0967 12.4248L14.2075 11.3681C14.264 11.3532 14.3176 11.3949 14.3176 11.4544V12.6451C14.3176 12.7135 14.273 12.779 14.2045 12.8058Z"
        fill={color || '#131925'}
      />
      <defs>
        <filter
          id="filter_metroActive"
          x="0.603385"
          y="0.0167187"
          width="41.7939"
          height="41.7939"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="1.41333" />
          <feGaussianBlur stdDeviation="1.76667" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default ActiveMetroIcon;
